module.exports = __webpack_public_path__ + "static/media/m3.e828ba57.png";